import "regenerator-runtime";
import * as React from "react";
import { CGI_BLACK } from "../helpers/enums";
import { Box, LinearProgress, Typography } from "@mui/material";

export default function OverallProgress(props) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: props?.customwidth || 1,
      }}
    >
      <Box sx={{ width: "100%", mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35, ml: props.customwidth ? -0.5 : 0 }}>
        <Typography
          sx={{ userSelect: "none" }}
          variant="body2"
          color={CGI_BLACK}
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}
